import { useCallback, useEffect, useRef } from 'react';

/**
 * ONE ANSWER PER LOAD: the latest. `begin()` tags a request and returns
 * `isCurrent()`, which turns false once a newer request has begun or the
 * component has gone. Open app A then quickly B, and A's answer arriving last
 * would otherwise land on B's page.
 *
 * One hook per kind of load: two loads sharing a `begin` would cancel each other.
 */
export default function useLatest() {
  const seq = useRef(0);
  useEffect(() => () => { seq.current += 1; }, []);
  return useCallback(() => {
    seq.current += 1;
    const mine = seq.current;
    return () => seq.current === mine;
  }, []);
}
